import Stripe from "stripe";

import Tag from "components/Tag";

const CouponComponent = ({ coupon }: { coupon: Stripe.Coupon }) => {
  return (
    <Tag className="text-gray-100 px-1 bg-green-600">
      <p className="text-lg md:text-xl sm:py-2 py-1 text-center">
        <span className="uppercase">{coupon.name}:</span>{" "}
        {coupon.percent_off ? (
          <span>{coupon.percent_off}%</span>
        ) : (
          <span>{coupon.amount_off}</span>
        )}{" "}
        off {coupon.duration}
        !!!
      </p>
    </Tag>
  );
};

export default CouponComponent;
